import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { STOP_DATE, START_DATE } from '../../../CampaignGoogleCreate/CampaignGoogleCreateForm/fields'
import { formatDateShort } from '../../../../../../constants/dates'

import { campaignSelector } from '../../../../../../modules/selectors/campaigns'

const DatesSectionPreview = () => {
  const { t } = useTranslation()

  const { [START_DATE]: startDate, [STOP_DATE]: endDate } = useSelector(campaignSelector)

  const formattedStartDate = useMemo(() => startDate && formatDateShort(startDate), [startDate])
  const formattedEndDate = useMemo(() => (endDate ? formatDateShort(endDate) : t('Ongoing')), [endDate, t])

  return (
    <p>
      {formattedStartDate}
      {formattedStartDate && formattedEndDate ? ' - ' : null}
      {formattedEndDate}
    </p>
  )
}

export default DatesSectionPreview
